import { defineEvent } from '../types/event';
export var QBS_MODAL_OPEN = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'Open_QBS_Modal'
        }
    ]
});
